import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAccountFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-5.782-4.47a8 8 0 1 1 11.531.033 9.518 9.518 0 0 0-.82-.458C15.538 16.413 13.89 16 12 16c-2.359 0-4.296.503-5.782 1.53ZM12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", fill: color }));
};
export default factorySvgIcon(SvgAccountFilled);
//# sourceMappingURL=SvgAccountFilled.js.map